module.exports = __webpack_public_path__ + "static/media/product_14.5e93fc17.jpg";